<template>
  <div class="communication-managament">
    <TableVisualizationLayout :leftAction="leftAction">
      <template slot="headerContent">
        <b-col class="pl-0 pr-0">
          <b-row class="mt-4 mb-4" align-h="between">
            <b-col class="pl-0 pr-0 custom-margim-top-header-input">
              <b-form-input
                id="input-1"
                class="text-left"
                v-model="filterSearch"
                type="text"
                placeholder="Busque por nome do comunicado…"
              ></b-form-input>
            </b-col>
            <b-col class="pl-0 pr-0 text-right custom-margim-top-header">
              <b-button
                id="button-generate-report"
                class="my-3"
                variant="primary"
                @click="onCreateReportClick()"
              >
                Gerar relatório
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </template>
      <template slot="table">
        <div class="scrollme">
          <b-table
            class="table-custom-communication spaced-text"
            :fields="fields"
            :items="items"
            v-show="!this.loading"
            show-empty
            empty-text="Nenhuma informação para exibir!"
          >
            <template #cell(visualize)="data">
              <div
                class="custom-row-table d-flex justify-content-center align-items-center"
              >
                <div
                  :id="'visualize-enabled-' + data.item.id"
                  class="mt-4 justify-content-center align-items-center custom-icon-visualize"
                  @click="onVisualizeClick(data.item)"
                ></div>
              </div>
            </template>
            <template #cell(report)="data">
              <div
                class="custom-row-table d-flex justify-content-center align-items-center"
              >
                <div
                  :id="'report-enabled-' + data.item.id"
                  v-if="data.item.action.showReport"
                  :class="'custom-icon-report-enable'"
                  class="mt-4 justify-content-center align-items-center custom-icon-report"
                  @click="onReportClick(data.item)"
                >
                  <b-tooltip
                    placement="top"
                    :target="'report-enabled-' + data.item.id"
                    >Ver relatório
                  </b-tooltip>
                </div>
                <div
                  :id="'report-disable-' + data.item.id"
                  v-if="!data.item.action.showReport"
                  :class="'custom-icon-report-disable'"
                  class="mt-4 justify-content-center align-items-center custom-icon-report"
                >
                  <b-tooltip
                    placement="top"
                    :target="'report-disable-' + data.item.id"
                    >Relatório não está disponível
                  </b-tooltip>
                </div>
              </div>
            </template>
            <template #cell(actions)="data">
              <div class="custom-actions d-flex justify-content-between">
                <div
                  class="icon icon-edit-enable"
                  @click="openFormEdit(data.item)"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Editar"
                ></div>

                <div
                  class="icon custom-icon-duplicate"
                  @click="onDuplicate(data.item)"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Duplicar"
                ></div>
                <div
                  class="icon"
                  :class="
                    data.item.action.canDelete
                      ? 'icon-delete-enable'
                      : 'icon-delete-disable'
                  "
                  @click="onDelete(data.item)"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Excluir"
                ></div>
              </div>
            </template>
          </b-table>
        </div>
        <div v-show="this.loading">
          <b-skeleton-table :rows="10" :columns="6"></b-skeleton-table>
        </div>
      </template>
      <template slot="footerContent">
        <div
          class="d-flex bd-highlight mb-3 justify-content-between"
          :class="isMobile() ? 'flex-column-reverse' : 'flex-row'"
          style="width: 100%"
        >
          <div :class="isMobile() ? 'align-self-center' : 'me-auto'">
            <b-button
              class="my-3"
              variant="primary"
              @click="openForm()"
              v-show="!this.loading"
            >
              Novo Comunicado
            </b-button>
          </div>
          <div
            class="mx-auto"
            :class="
              isMobile() ? '' : 'pagination-communication align-self-center'
            "
          >
            <b-pagination
              v-model="page"
              :total-rows="totalSize"
              :per-page="perPage"
              aria-controls="my-table"
              size="lg"
            />
          </div>
        </div>
      </template>
    </TableVisualizationLayout>
    <success-modal
      ref="success-modal"
      :description="this.msgSuccess"
      buttonText="Ok, entendi!"
    />
    <attention-modal
      modalId="delete-communication-modal"
      title="Atenção!"
      submitButtonText="Sim"
      cancelButtonText="Não"
      ref="delete-communication-attention-modal"
      :onAction="this.onDeleteConfirm"
    >
      <template slot="description">
        <p class="p1 mb-5 confirm-text">
          Tem certeza que deseja excluir este comunicado?
        </p>
      </template>
    </attention-modal>
    <attention-modal
      modalId="validate-delete-attention-modal"
      title="Atenção!"
      submitButtonText="Ok, entendi!"
      ref="attention-modal"
      :onAction="this.onAttentionConfirm"
    >
      <template slot="description">
        <div class="justify-content-center text-center w-100">
          <p class="p1 mb-5 confirm-text">
            {{ alertValidationMessage }}
          </p>
        </div>
      </template>
    </attention-modal>
    <Communication
      modalId="communication-preview-modal"
      :visualization="this.itemToVisualization"
    />
  </div>
</template>

<script>
import _ from "lodash";
import TableVisualizationLayout from "../../../layouts/TableVisualizationLayout.vue";
import { resolve_path_url } from "../../../utils/image/image-utils";
import { isMobile } from "../../../utils/mobile/mobile";
import RoutesPaths from "../../../router/router-structure/routes-paths";
import AttentionModal from "../../../components/base-modals/AttentionModal.vue";
import SuccessModal from "../../../components/base-modals/SuccessModal.vue";
import Communication from "../../communication/views/Communication.vue";
import {
  getCommunications,
  deleteCommunication,
  repostCommunicationEvent,
} from "../../../services/communication/communication";
import { anchorBase64Download } from "../../../utils/anchor-base64-download/anchor-base64-download";

import { createToast } from "../../../components/toast/toast";

export default {
  components: {
    TableVisualizationLayout,
    AttentionModal,
    SuccessModal,
    Communication,
  },
  mounted() {
    this.getCommunicationsHandler();
  },
  computed: {
    shouldFetchData() {
      return this.filterSearch.length > 2 || this.filterSearch.length == 0;
    },
  },
  watch: {
    page: {
      handler() {
        this.getCommunicationsHandler();
      },
    },
    filterSearch: {
      handler: _.debounce(function () {
        if (this.shouldFetchData) {
          this.getCommunicationsHandler();
        }
      }, 500), // Espera 500ms antes de chamar a função
      immediate: false,
    },
  },
  data() {
    return {
      filterSearch: "",
      itemToVisualization: null,
      page: 1,
      perPage: 10,
      totalSize: 10,
      msgSuccess: "",
      leftAction: {
        text: "Gestão de comunicados",
        onClick: this.leftActionClickHandler,
      },
      fields: [
        {
          key: "name",
          label: "Nome",
          thStyle: { width: "40%" },
        },

        {
          key: "dateInicial",
          label: "Data início",
          thStyle: { width: "15%" },
        },
        {
          key: "dateFinal",
          label: "Data fim",
          thStyle: { width: "15%" },
        },
        {
          key: "visualize",
          label: "Visualizar",
          class: "text-center",
          thStyle: { width: "10%" },
        },
        {
          key: "report",
          label: "Relatório",
          class: "text-center",
          thStyle: { width: "10%" },
        },
        {
          key: "actions",
          label: "Ações",
          class: "text-center",
          thStyle: { width: "10%" },
        },
      ],
      items: [],
      loading: false,
      resolve_path_url,
      alertValidationMessage: "",
    };
  },
  methods: {
    onCreateReportClick() {
      this.$router.push({
        path: RoutesPaths.communicationManagement.reportManagement(),
      });
    },
    isMobile: isMobile,
    onDuplicate(item) {
      this.$router.push({
        path: RoutesPaths.communicationManagement.form(item?.id),
        query: { toClone: true },
      });
    },
    openFormEdit(item) {
      this.$router.push({
        path: RoutesPaths.communicationManagement.form(item.id),
      });
    },
    openForm() {
      this.$router.push({
        path: RoutesPaths.communicationManagement.form(),
      });
    },
    async getCommunicationsHandler() {
      try {
        this.loading = true;
        const response = await getCommunications(
          this.page - 1,
          this.perPage,
          this.filterSearch
        );
        this.items = response.items;
        this.totalSize = response.totalItems;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error("getCommunicationsHandler", error);
      }
    },
    async onDelete(item) {
      if (!item.action.canDelete) return;

      this.itemToDelete = item;
      const modal =
        this.$refs["delete-communication-attention-modal"].$children[0];
      modal.show();
    },
    async onDeleteConfirm(confirmed) {
      if (!confirmed) return;
      try {
        await deleteCommunication(this.itemToDelete.id);
        this.msgSuccess = "Comunicado excluído com sucesso!!";
        const modal = this.$refs["success-modal"].$children[0];
        modal.show();
        this.page = 1;
        this.getCommunicationsHandler();
      } catch (e) {
        if (
          e.response &&
          e.response.data &&
          e.response.data.error_code &&
          e.response.data.error_code == "COMMUNICATION_NOT_DELETE"
        ) {
          this.showValidationAlert(e.response.data.message);
        }
        console.error("onSubmit", e);
        createToast(
          "Atenção",
          "Ocorreu um erro atualizar as informações do evento."
        );
      }
    },
    showValidationAlert(message) {
      this.alertValidationMessage = message;
      const modal = this.$refs["attention-modal"].$children[0];
      modal.show();
    },
    onAttentionConfirm() {
      const modal = this.$refs["attention-modal"].$children[0];
      modal.hide();
    },
    leftActionClickHandler() {
      this.$router.push({
        path: RoutesPaths.home.rootName(),
        replace: true,
      });
    },
    async onReportClick(item) {
      this.loading = true;
      try {
        const reportResponse = await repostCommunicationEvent(item.id);

        anchorBase64Download(
          null,
          "application/xls",
          item.name + reportResponse.extension,
          reportResponse.fileBase64
        );
      } catch (err) {
        console.error(err);
        this.loading = false;

        createToast(
          "Atenção",
          "Ocorreu um erro fazer download do relatório de evento(s)."
        );
      }
      this.loading = false;
    },
    async onVisualizeClick(item) {
      this.itemToVisualization = item;
      this.$bvModal.show("communication-preview-modal");
    },
  },
};
</script>
<style lang="scss">
div.table-custom-communication td {
  color: #7a7e83;
  padding-left: 2rem;
}
div.table-custom-communication th {
  padding-left: 2rem;
}

#communication-preview-modal div.modal-content {
  padding: 0 !important;
  margin-top: 2rem;
}
#communication-preview-modal footer.modal-footer {
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
.custom-icon-report {
  &-enable {
    background-image: url("../../../assets/icons/training-report-enable.svg");

    &:hover {
      cursor: pointer;
    }
  }

  &-disable {
    background-image: url("../../../assets/icons/training-report-disable.svg");
  }

  background-repeat: no-repeat;
  width: 22px;
  height: 36px;
}
.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}

.itemleft {
  position: absolute;
  left: 0;
}
.icon {
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;

  &-edit-enable {
    background-image: url("../../../assets/icons/pencil-outline.svg");
    background-repeat: no-repeat;
    width: 32px;
    height: 25px;
    border-radius: 30px;
    background-position: center;
    cursor: pointer;
    &:hover {
      background: rgba(1, 157, 95, 0.1) 0% 0% no-repeat padding-box;
      background-image: url("../../../assets/icons/pencil-outline-houver.svg");
      background-position: center;
    }
  }

  &-edit-disable {
    background-image: url("../../../assets/icons/pencil-outline.svg");
    opacity: 0.5;
    background-repeat: no-repeat;
    width: 32px;
    height: 25px;
    border-radius: 30px;
    background-position: center;

    &:hover {
      cursor: default !important;
      background-position: center;
    }
  }

  &-delete-enable {
    background-image: url("../../../assets/icons/trash-can-outline.svg");
    background-repeat: no-repeat;
    width: 36px;
    height: 25px;
    border-radius: 30px;
    background-position: center;
    &:hover {
      background: rgba(213, 36, 83, 0.1) 0% 0% no-repeat padding-box;
      background-image: url("../../../assets/icons/trash-can-outline-houver.svg");
      background-position: center;
    }
  }

  &-delete-disable {
    float: left;
    background-image: url("../../../assets/icons/trash-can-outline-disable.svg");

    &:hover {
      cursor: default !important;
    }
  }

  &-duplicate {
    background-image: url("../../../assets/icons/clone.svg");
    float: left;
    margin-left: 6px;

    &:hover {
      background: rgba(1, 157, 95, 0.1) 0% 0% no-repeat padding-box;
      background-image: url("../../../assets/icons/clone-hover.svg");
      background-position: center;
      border-radius: 30px;
    }
  }

  &:hover {
    cursor: pointer;
  }
}
.confirm-text {
  margin: auto;
}
.custom-actions {
  width: 90%;
}

.custom-cursor-status {
  &-disable {
    &:hover {
      cursor: default !important;
    }
  }

  &:hover {
    cursor: pointer;
  }
}
.icon {
  padding: 1.4rem;
}
.custom-icon-duplicate {
  background-image: url("../../../assets/icons/clone.svg");
  background-repeat: no-repeat;
  width: 36px;
  height: 25px;
  border-radius: 30px;
  background-position: center;
  cursor: pointer;
  &:hover {
    background: rgba(1, 157, 95, 0.1) 0% 0% no-repeat padding-box;
    background-image: url("../../../assets/icons/clone-hover.svg");
    background-position: center;
  }
}
.custom-icon-delete {
  background-image: url("../../../assets/icons/trash-can-outline.svg");
  background-repeat: no-repeat;
  width: 36px;
  height: 25px;
  border-radius: 30px;
  background-position: center;
  &:hover {
    background: rgba(213, 36, 83, 0.1) 0% 0% no-repeat padding-box;
    background-image: url("../../../assets/icons/trash-can-outline-houver.svg");
    background-position: center;
  }
}
.custom-actions div:not(:last-child) {
  margin-right: 1.2rem;
}
.pagination-training ul {
  margin-bottom: 0rem;
}
.scrollme {
  overflow-x: auto;
}

.custom-margim-top-header-input {
  margin-top: 14px;
}
.custom-icon-visualize {
  background-image: url("../../../assets/icons/MDI-eye.svg");
  &:hover {
    cursor: pointer;
  }
  background-repeat: no-repeat;
  width: 25px;
  height: 36px;
}
</style>
